export const ItemTypes = {
  PAGE: "PAGE",
  FILE: "FILE"
};
